// extracted by mini-css-extract-plugin
export default {"score_card":"ScoreCard_score_card__fNXzX","score_card__heading":"ScoreCard_score_card__heading__sOgs5","score_card__score":"ScoreCard_score_card__score__1Ytez"};